import { soddApi } from "./soddApi";

export const projectApi = soddApi
    .enhanceEndpoints({
        addTagTypes: ["project", "project.size", "project.duration"],
    })
    .injectEndpoints({
        endpoints: (build) => ({
            getProjectPropertySizes: build.query({
                // project-config
                query: (params) => ({
                    url: "api/v1/project-property/sizes",
                    method: "GET",
                    parmas: params,
                }),
                providesTags: ["project.size"],
            }),
            getProjectPropertyDurations: build.query({
                query: (params) => ({
                    url: "api/v1/project-property/durations",
                    method: "GET",
                    parmas: params,
                }),
                providesTags: ["project.duration"],
            }),
            // project
            createProject: build.mutation({
                query: (data) => ({
                    url: "api/v1/projects",
                    method: "POST",
                    body: data,
                }),
                invalidatesTags: ["project"],
            }),
            getAllProjects: build.query({
                query: (params) => ({
                    url: "api/v1/projects",
                    method: "GET",
                    params: params,
                }),
                providesTags: ["project"],
            }),
            getProjectById: build.query({
                query: (projectId) => ({
                    url: `api/v1/projects/${projectId}`,
                    method: "GET",
                }),
                providesTags: (_result, _error, args) => {
                    const projectId = args;
                    return Boolean(projectId) ? [{ type: "project", id: projectId }] : "project";
                },
            }),
            updateProjectSettingGeneral: build.mutation({
                query: ({ projectId, ...data }) => ({
                    url: `api/v1/projects/${projectId}/settings/general`,
                    method: "POST",
                    body: data,
                }),
                invalidatesTags: (_result, _error, args) => {
                    const { projectId } = args;
                    return Boolean(projectId) ? [{ type: "project", id: projectId }] : "project";
                },
            }),
            updateProjectSettingInfo: build.mutation({
                query: ({ projectId, ...data }) => ({
                    url: `api/v1/projects/${projectId}/settings/info`,
                    method: "POST",
                    body: data,
                }),
                invalidatesTags: (_result, _error, args) => {
                    const { projectId } = args;
                    return Boolean(projectId) ? [{ type: "project", id: projectId }] : "project";
                },
            }),
        }),
    });
